import styled from 'styled-components';

import chevronRightBlack from '../../../images/common/chevron-right-black.svg';

export const OtherCasesStyled = styled.div`
  position: relative;
  padding-bottom: 60px;
  background: var(--lgray);
  .container {
    .desktop {
      display: none;
      @media (min-width: 992px) {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }
    }
    .mobile {
      display: flex;
      justify-content: center;
      @media (min-width: 992px) {
        display: none;
      }
    }
  }
  @media (min-width: 992px) {
    padding-bottom: 270px;
  }
`;

export const UseCasesDiagonalGrayTop = styled.div`
  background: var(--dwhite);
  width: 100%;
  height: 90px;
  clip-path: polygon(0 75%, 100% 0, 100% 0, 0 0);
  @media (min-width: 992px) {
    height: 320px;
    clip-path: polygon(0 100%, 100% 50%, 100% 0, 0 0);
    position: absolute;
  }
`;

export const Title = styled.h4`
  color: var(--black);
  font-family: Rubik;
  font-size: 32px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 40px;
  text-align: center;
  position: relative;
  z-index: 1;
  @media (min-width: 992px) {
    width: 168px;
  }
`;

export const PaginationPill = styled.div`
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--gray-pill);
  height: 56px;
  width: 149px;
  color: var(--black);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  text-align: center;
  padding: 4px;
  border-radius: 32px;
  margin-left: 20px;
`;

export const SliderContainer = styled.div`
  margin-top: 50px;
  margin-bottom: 80px;
  .slick-slider {
    .slick-list {
      .slick-track {
        padding: 0 20px;
        .slick-slide {
          padding: 40px 0;
          margin: -3px 0;
          &:not(:last-of-type) {
            > div {
              margin-right: 24px;
            }
          }
        }
      }
    }
    .slick-arrow {
      top: unset;
      bottom: -40px;
      transform: unset;
      cursor: pointer;
      &.slick-prev {
        left: 10%;
        transform: rotate(180deg);
        &::before {
          background-image: url('${chevronRightBlack}');
          background-size: 20px 20px;
          display: inline-block;
          width: 20px;
          height: 20px;
          content: '';
        }
        @media (min-width: 414px) {
          left: 8%;
        }
        @media (min-width: 768px) {
          left: 5%;
        }
      }
      &.slick-next {
        right: unset;
        left: 33%;
        &::before {
          background-image: url('${chevronRightBlack}');
          background-size: 20px 20px;
          display: inline-block;
          width: 20px;
          height: 20px;
          content: '';
        }
        @media (min-width: 414px) {
          left: 31%;
        }
        @media (min-width: 768px) {
          left: 17%;
        }
      }
    }
  }
  @media (min-width: 992px) {
    display: none;
  }
`;

export const Btn = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  min-height: 40px;
  width: 138px;
  border-radius: 32px;
  background-color: var(--pink);
  border: 1px solid var(--pink);
  color: var(--white);
  font-family: Rubik;
  font-size: 12px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  &:hover {
    color: var(--pink);
    background: var(--white);
  }
`;

export const Card = styled.div`
  box-sizing: border-box;
  height: 304px;
  width: 264px;
  border-radius: 20px;
  background-color: var(--white);
  box-shadow: 0 0 50px 0 rgba(4, 30, 66, 0.1);
  padding: 32px;
  cursor: pointer;
  transition: transform 0.2s ease;
  position: relative;
  z-index: 0;
  outline: none;
  @media (min-width: 992px) {
    &:hover {
      box-shadow: 0 0 50px 0 rgba(4, 30, 66, 0.2);
      transform: scale(1.1);
      z-index: 1;
    }
  }
`;

export const CardMobile = styled.div`
  box-sizing: border-box;
  height: 304px;
  width: 264px;
  border-radius: 20px;
  background-color: var(--white);
  box-shadow: 0 0 50px 0 rgba(4, 30, 66, 0.1);
  padding: 32px;
  cursor: pointer;
  transition: transform 0.2s ease;
  position: relative;
  z-index: 0;
  outline: none;
  @media (min-width: 992px) {
    &:hover {
      box-shadow: 0 0 50px 0 rgba(4, 30, 66, 0.2);
      transform: scale(1.1);
      z-index: 1;
    }
  }
`;

export const CardOutter = styled.div`
  display: none;
  &.showing {
    display: block;
  }
  &.showing:nth-of-type(1) {
    animation-delay: 1s;
    margin-right: 24px;
  }
  &.showing:nth-of-type(2) {
    animation-delay: 1s;
    margin-right: 24px;
  }
  &.showing:nth-of-type(2) {
    animation-delay: 1.5s;
    margin-right: 24px;
  }
  &.showing:nth-of-type(3) {
    animation-delay: 2s;
    margin-right: 24px;
  }
  &.showing:nth-of-type(3) {
    animation-delay: 2.5s;
    margin-right: 24px;
  }
  &.showing:nth-of-type(4) {
    animation-delay: 3s;
    margin-right: 24px;
  }
  &.showing:nth-of-type(4) {
    animation-delay: 3s;
    margin-right: 24px;
  }
  &:not(:last-of-type) {
    margin-right: 24px;
  }
`;

export const CardsContainer = styled.div`
  @media (min-width: 992px) {
    display: flex;
    justify-content: space-between;
  }
`;

export const CardIconContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const CardTitle = styled.h4`
  color: var(--black);
  font-family: Rubik;
  font-size: 24px;
  letter-spacing: 0;
  line-height: 32px;
  width: 200px;
  min-height: 152px;
`;
